<div class="acs-loading-spinner-container" [class.overlay]="overlay">
  <div class="spinner-wrapper">
    <div class="spinner" [class.spinner-small]="size === 'small'" 
         [class.spinner-medium]="size === 'medium'"
         [class.spinner-large]="size === 'large'"></div>
    <p class="loading-message" *ngIf="message">{{ message }}</p>
  </div>
</div>
